import { getSettings } from '@wix/ambassador-pricing-plans-v2-settings/http';
import { ControllerFlowAPI, IHttpClient } from '@wix/yoshi-flow-editor';

type ErrorHandler = ControllerFlowAPI['errorHandler'];

export function createSettingsApi(flowAPI: ControllerFlowAPI) {
  return new SettingsApi(flowAPI.httpClient, flowAPI.errorHandler);
}

export class SettingsApi {
  constructor(private httpClient: IHttpClient, private errorHandler: ErrorHandler) {}

  async getSettings() {
    const response = await this.errorHandler.withErrorHandler(() => this.httpClient.request(getSettings({})), {
      errorCodesMap: { applicationError: {} },
    });
    return response.data.settings;
  }
}
